module.exports = __webpack_public_path__ + "img/vmc_aniv25_24Aug2021.3df04140.jpg";